import React from 'react'
import './IntroHero.css';
import greenBg from '../../assets/greenbg.png';
import WordRotate from '../../UI/WordRotate';
// import heroVid from '../../assets/small4k.webm';
import HeroImage from '../../assets/HeroImg.png';
import CustomGreenButton from '../../UI/Intro/customButton/customGreenButton';
import { useNavigate } from 'react-router-dom';

const IntroHero = () => {
  const navigate = useNavigate();
  return (
    <div className='hero-outer'>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center', justifyContent: 'center' }}>
        <div className='word-rotate'>
          <WordRotate />
        </div>
        <p className="intro-hero-title">All in the Cloud</p>
        <p className="intro-hero-body">
          Launch powerful tools, explore cutting-edge software, and unlock innovation<br />—no installations, no subscriptions, just possibilities.
        </p>
      </div>
      <div style={{ display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'center', paddingTop: '60px', paddingBottom: '50px' }}>
        <CustomGreenButton width="150px" firstText="Start Now" secondText="Start Now" handleClick={() => navigate('/login')} />
      </div>

      <div className="hero-bg-stack responsive-hero-bg-stack" >
        <video className="hero-bg-video" src="https://developer-s3-mh-dev.s3.ap-south-1.amazonaws.com/Cloudlab/small4k.webm" autoPlay loop muted playsInline />
        <img className="hero-bg-green" src={greenBg} alt="Green Background" />
        <img className="hero-bg-image" src={HeroImage} alt="Hero" />
        <div className="hero-bg-vignette"></div>
      </div>
    </div>
  )
}

export default IntroHero